(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  // ---- KSD-67: los puntos siguen al anuncio visible ----
  //
  // `announcement-bar.js` de Horizon no publica el índice actual: su setter
  // `current` sólo cambia el `aria-hidden` de cada diapositiva. Comprobado —
  // no hay evento ni atributo en el elemento. Así que en vez de tocar su
  // componente, se observa ese mismo `aria-hidden`, que es su salida.
  //
  // Observar en lugar de llevar la cuenta aparte evita el fallo clásico: con
  // dos fuentes de verdad, el punto y el mensaje se desincronizan en cuanto
  // algo reinicia el carrusel (la pestaña se oculta y vuelve, por ejemplo).
  (() => {
    const init = (barra) => {
      const caja = barra.querySelector('[data-kh-dots]');
      const comp = barra.querySelector('announcement-bar-component');
      const slides = [...barra.querySelectorAll('.announcement-bar__slide')];
      if (!slides.length) return;

      // Si ninguna arranca visible, se enciende la primera. Esto NO es un
      // extra: Liquid marca el bloque 0 y punto, y ese bloque puede no pintar
      // diapositiva —si lleva una cifra y su ajuste vale cero—, así que la
      // barra arrancaría en blanco. Desde un bloque no se puede saber cuál es
      // el primero que de verdad se pinta (`section.blocks` devuelve a los
      // hermanos vacíos; está medido en el comentario de _announcement), y
      // aquí sí se ven las diapositivas reales. O sea: esto es lo que lo
      // arregla.
      //
      // Va ANTES de la salida por «menos de dos»: con un solo anuncio no hay
      // rotación ni puntos, pero sí tiene que verse.
      if (!slides.some((s) => s.getAttribute('aria-hidden') === 'false')) {
        slides[0].setAttribute('aria-hidden', 'false');
      }

      if (!caja || !comp || slides.length < 2) return;

      // UNO POR DIAPOSITIVA, no por bloque: un bloque sin texto no pinta
      // diapositiva y los puntos quedarían descuadrados.
      const plantilla = caja.dataset.dotLabel || '%N%';
      caja.replaceChildren();
      const puntos = slides.map((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'kh-ann__dot';
        b.setAttribute('aria-label', plantilla.replace('%N%', String(i + 1)));
        // Reiniciar el reloj al elegir: sin esto el intervalo sigue su
        // horario viejo y el mensaje recién elegido se cambia casi al
        // instante. `suspend` + `resume` es la pareja que expone Horizon.
        b.addEventListener('click', () => {
          comp.suspend?.();
          comp.current = i;
          comp.resume?.();
        });
        caja.appendChild(b);
        return b;
      });

      const pintar = () => {
        slides.forEach((slide, i) => {
          const visible = slide.getAttribute('aria-hidden') === 'false';
          puntos[i].classList.toggle('is-on', visible);
          // `aria-current` dice CUÁL es, no sólo que hay uno encendido: el
          // color no llega a quien no ve.
          if (visible) puntos[i].setAttribute('aria-current', 'true');
          else puntos[i].removeAttribute('aria-current');
        });
      };

      const obs = new MutationObserver(pintar);
      slides.forEach((s) => obs.observe(s, { attributes: true, attributeFilter: ['aria-hidden'] }));
      pintar();

      // Quien pidió menos movimiento no debería tener un texto rotando solo
      // (WCAG 2.2.2). En escritorio además se pausa al pasar el ratón, que
      // es cosa de Horizon; en táctil no hay equivalente y queda anotado en
      // el ticket.
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) comp.pause?.();
    };

    const arrancar = () => document.querySelectorAll('.announcement-bar').forEach(init);
    arrancar();

    // El editor vuelve a pintar la sección sin recargar la página, y
    // entonces los puntos nuevos nacen sin sus manejadores. Sólo afecta a
    // quien edita, pero cuesta una línea.
    document.addEventListener('shopify:section:load', (e) => {
      const sec = e.target instanceof Element ? e.target : null;
      (sec ? sec.querySelectorAll('.announcement-bar') : []).forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
